import * as React from "react"
import { type Contact } from "@digits-graphql/frontend/graphql-public"
import { ColorIcon } from "@digits-shared/components/UI/Elements/ColorIcon"
import userHelper from "@digits-shared/helpers/userHelper"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"

/*
  STYLES
*/

const UserContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 17px;
`

const Name = styled.div`
  font-weight: ${fonts.weight.heavy};
  font-size: 14px;
`

/*
  COMPONENTS
*/

export const UserInfo: React.FC<{ className?: string; contact: Contact }> = ({
  className,
  contact,
}) => {
  const name = userHelper.displayName(contact)
  return (
    <UserContainer className={className}>
      <ColorIcon imageUrl={contact.avatarUrl} fallbackUser={contact} size={16} />
      <Name>{name}</Name>
    </UserContainer>
  )
}
